export interface Testimonial {
  id: string;
  name: string;
  location: string;
  rating: number;
  service: string;
  text: string;
  date: string;
  initials: string;
}

export const testimonials: Testimonial[] = [
  {
    id: '1',
    name: 'Margaret T.',
    location: 'Jacksonville, FL',
    rating: 5,
    service: 'Chimney Cleaning',
    text: 'BBM Services came out and did a fantastic job cleaning our chimney. The technician was professional, on time, and explained everything clearly. Our fireplace is running perfectly now. Highly recommend for any Jacksonville homeowner.',
    date: 'January 2026',
    initials: 'MT',
  },
  {
    id: '2',
    name: 'Carlos R.',
    location: 'Ponte Vedra Beach, FL',
    rating: 5,
    service: 'Air Duct Cleaning',
    text: 'I noticed my allergies were terrible indoors. BBM Services came out and cleaned our air ducts — the difference was immediate. The air feels cleaner and my family is breathing better. Worth every penny. Will absolutely use again.',
    date: 'February 2026',
    initials: 'CR',
  },
  {
    id: '3',
    name: 'Sandra K.',
    location: 'Orange Park, FL',
    rating: 5,
    service: 'Dryer Vent Cleaning',
    text: 'My dryer was taking forever to dry clothes. BBM Services came out within a day and the technician pulled out an unbelievable amount of lint. My dryer works like new now. Fast, affordable, and professional. Thank you!',
    date: 'January 2026',
    initials: 'SK',
  },
  {
    id: '4',
    name: 'James W.',
    location: 'Jacksonville Beach, FL',
    rating: 5,
    service: 'Chimney Cleaning',
    text: 'We hadn\'t had our chimney cleaned in years. BBM Services was thorough, professional, and gave us a detailed inspection report. The technician caught a minor crack we didn\'t know about. Great attention to detail — I\'m impressed.',
    date: 'December 2025',
    initials: 'JW',
  },
  {
    id: '5',
    name: 'Patricia M.',
    location: 'Mandarin, FL',
    rating: 5,
    service: 'Air Duct Cleaning',
    text: 'BBM Services was recommended by my neighbor and they did not disappoint. Cleaned all our ducts, sanitized the system, and showed me before and after photos. Our HVAC is running more efficiently and the house smells fresher.',
    date: 'February 2026',
    initials: 'PM',
  },
  {
    id: '6',
    name: 'David L.',
    location: 'Nocatee, FL',
    rating: 5,
    service: 'Dryer Vent Cleaning',
    text: 'Quick, clean, and affordable. The technician arrived on time, completed the dryer vent cleaning efficiently, and explained the fire risk I had been ignoring. Super glad I called BBM Services. Booking annually from now on.',
    date: 'March 2026',
    initials: 'DL',
  },
];
